import { RoutePath } from "#src/utils/route";
import { WorkerRoutePath } from "..";

export const WorkerDetailRoutePath = WorkerRoutePath.concat(
  new RoutePath({
    path: "/detail",
    title: "Worker Detail",
  })
);
